import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedCarGroup: { positionType: {}, ubsCarType: {} },
    carTypes: [],
  }),

  mutations: {
    setSelectedCarGroup(state, selectedCarGroup) {
      Vue.set(state, "selectedCarGroup", selectedCarGroup);
    },
    setCarGroups(state, carGroups) {
      Vue.set(state, "carGroups", carGroups);
    },
    setDefaultCarGroupModule(state, carGroups) {
      Vue.set(state, "selectedCarGroup", { positionType: {}, ubsCarType: {} });
      Vue.set(state, "carTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createCarGroup: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/car-types/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadCarGroups: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadCarGroup: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedCarGroup", response.data);
        return response.data;
      });
    },

    loadPublishedCarGroups: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/entity/published").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    // loadPublishedCarGroups: (context)=>{
    //     return axios.get(context.getters.getMcServiceUrl+'/car-types/entity/published')
    //         .then((response) => {
    //             return response.data;
    //         })
    // },
    loadCarGroupHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/car-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedCarGroupHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    searchCarGroupByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/car-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteCarGroup: (context, carType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/car-types/entity/" + carType.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          carType.intents = intents;
          carType.intentId = response.data.id;
          return carType;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftCarGroup: (context, carType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/car-types/draft/" + carType.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishCarGroup: (context, carType) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/publish/" + carType.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectCarGroup: (context, carType) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/reject/" + carType.intentId).then((response) => {
        if (carType.intents[0].type === "DELETE_CAR_TYPE") {
          carType.intents = null;
          carType.intentId = 0;
        } else if (carType.intents[0].type === "CREATE_CAR_TYPE") {
          carType.intents[0].status = "DRAFT";
        } else if (carType.intents[0].type === "UPDATE_CAR_TYPE") {
          carType.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalCarGroup: (context, carType) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/sendToApproval/" + carType.intentId).then((response) => {
        if (carType.intents[0].type === "CREATE_CAR_TYPE") {
          carType.intents[0].status = "WAITING_APPROVAL";
        } else if (carType.intents[0].type === "UPDATE_CAR_TYPE") {
          carType.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallCarGroup: (context, carType) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/recall/" + carType.intentId).then((response) => {
        helper.recallOrRejectEntity(carType, "car_type");
        return response.data;
      });
    },
    cancelCarGroup: (context, carType) => {
      return axios.get(context.getters.getMcServiceUrl + "/car-types/cancel/" + carType.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedCarGroup: (state) => {
      return state.selectedCarGroup;
    },
    getCarGroups: (state) => {
      return state.carGroups;
    },
    getPublishedCarTypes: (state) => {
      return state.carGroups.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
